<div class="content">
  <div class="container-fluid about">
    <div class="page-title">
      <h1 class="float-left">
        {{'Smart Power Report' | translate}}
        <small>
          <a [routerLink]="'/help/smart-power-report'" target="_blank">
            <i class="fa fa-question-circle" aria-hidden="true"></i>
          </a>
        </small>
      </h1>
      <div>
        <button class="ui-button-danger float-right" type="button" pButton label="{{'Recipent Settings' | translate}}" icon="fa fa-cog" (click)="showReportSetting()" *ngIf="!isMsp"></button>
        <button class="ui-button-danger float-right" type="button" pButton label="{{'Recipent Settings' | translate}}" icon="fa fa-cog" (click)="routeToProAccount()" *ngIf="isMsp && IsAdmin"></button>
      </div>
    </div>
    <section>
      <div class="page-filter clearfix multiple-filter">
        <div class="filter-flex">
          <div class="filter">
            <div class="filter-list name_title">
              <div class="filter-content date">
                <p-datepicker [(ngModel)]="filterDate" view="month" dateFormat="mm/yy" [yearNavigator]="true" yearRange="2000:2050" [showIcon]="true"
                            (ngModelChange)="onMonthChange($event)"></p-datepicker>
              </div>
            </div>
            <div class="filter-list name_title" *ngIf="isMsp">
              <div class="filter-content">
                <p-select [options]="regionOption" [(ngModel)]="selectRegion" (onChange)="filterReportList()" [style]="{'width':'100%'}"></p-select>
              </div>
            </div>
            <div class="filter-list">
              <p-selectButton [options]="lastFiveWeeksOptions" [(ngModel)]="lastFiveWeeksValue" (onChange)="handleButtonClick($event)"></p-selectButton>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section style="margin-top: 30px">
      <div class="page-title flex">
        <h5 class="float-left">{{'Weekly Report' | translate}}</h5>
      </div>
      <div class="page-content weekly-report-container">
        <div *ngFor="let week of weekInfoData" class="week-block" [class.selected]="week.weekNumber === selectedWeek">
          <div class="week">
            <div class="th">
              <div class="week-number">WK {{ week.weekNumber }}</div>
            </div>
            <div class="td" (click)="selectWeek(week)" [ngClass]="getCalendarWeekClass(week)">
              <div class="week-date-range">{{ week.startDateStr }} - {{ week.endDateStr }}</div>
              <div class="flex-status">
                <div class="row">
                  <div class="col-md-12">
                    <div class="status-list">
                      <div class="score">{{week.powerProtection}}</div>
                      <div class="txt">{{'Power Threat Blocked' | translate}}</div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="status-list">
                      <div class="score">
                        {{ week.riskRate === '-' ? '-' : week.riskRate + '%' }}
                      </div>
                      <div class="txt">{{'Time-At-Risk' | translate}}</div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="status-list">
                      <div class="score {{week.loadDistribution}}">{{week.loadDistribution}}</div>
                      <div class="txt">{{'Load Approaching Peak Capacity' | translate}}</div>
                    </div>
                  </div>
                  <!-- <div class="col-md-6">
                    <div class="status-list">
                      <div class="score {{week.energySaving == 'A+' ? 'Plus' : week.energySaving}}">{{week.energySaving === 'A+' ? 'A' : week.energySaving}}</div>
                      <div class="txt">{{'Energy & Saving' | translate}}</div>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section style="margin-top: 30px">
      <div class="page-title flex">
        <h5 class="float-left">{{'Monthly Report' | translate}}</h5>
      </div>
      <div class="page-content monthly-report-container">
        <div *ngFor="let month of monthInfoArray" class="month-block">
          <div class="month">
            <div class="th">
              <div class="week-date-range">{{monthMap[month.month] | translate}}</div>
            </div>
            <div class="td {{month.status}}" (click)="selectMonth(month.month)">
              <div class="flex-status">
                <div class="row">
                  <div class="col-md-12">
                    <div class="status-list">
                      <div class="score">{{month.powerProtection}}</div>
                      <div class="txt">{{'Power Threat Blocked' | translate}}</div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="status-list">
                      <div class="score">
                        {{ month.riskRate === '-' ? '-' : month.riskRate + '%' }}
                      </div>
                      <div class="txt">{{'Time-At-Risk' | translate}}</div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="status-list">
                      <div class="score">{{month.loadDistribution}}</div>
                      <div class="txt">{{'Load Approaching Peak Capacity' | translate}}</div>
                    </div>
                  </div>
                  <!-- <div class="col-md-6">
                    <div class="status-list">
                      <div class="score {{month.energySaving == 'A+' ? 'Plus' : month.energySaving}}">{{month.energySaving === 'A+' ? 'A' : month.energySaving}}</div>
                      <div class="txt">{{'Energy & Saving' | translate}}</div>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>

<p-dialog header="{{'Recipent Settings' | translate}}" [(visible)]="reportSettingsDialog" [modal]="true" [responsive]="true" [style]="{'width': '550px'}" [minWidth]="200" [baseZIndex]="10000" [blockScroll]="true">
  <!-- <p-tabView class="settings_tabView" [activeIndex]="reportSettingDefaultTab" (onChange)="onTabChange($event)">
    <p-tabPanel>
      <ng-template pTemplate="header">{{'Weekly Report' | translate}}</ng-template>
      <div class="dialog-content">
        <div class="form-group type">
          <div class="flex">
            <div>
              <label>{{'Enable Weekly Report' | translate}}</label>
              <small>{{'Reports are generated automatically and will only be sent via email when this feature is enabled.' | translate}}</small>
            </div>
            <p-inputSwitch [(ngModel)]="dialogReportSettingInput.weeklyEnable"></p-inputSwitch>
          </div>
        </div>
        <div class="form-group" style="margin-bottom: 0 !important;">
          <label>{{'Recipient Group' | translate}}</label>
        </div>
        <p-table class="recipientTable report" [ngClass]="{'border-top': weeklyRecipientGroup.length> 0 }" [value]="weeklyRecipientGroup" [(selection)]="weeklySelectedGroups" [paginator]="false" [rows]="10" [scrollable]="true">
          <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
            <tr [pSelectableRow]="rowData" [pSelectableRowIndex]="rowIndex">
              <td style="width: 40px; text-align: right;">
                <p-tableCheckbox [value]="rowData" [index]="rowIndex" [disabled]="!dialogReportSettingInput.weeklyEnable"></p-tableCheckbox>
              </td>
              <td class="col-nowrap">
                <div class="recipient">
                  <div class="data">
                    <h5 style="margin: 0;">{{rowData.GroupName}} <span *ngIf="this.currentUser === rowData.GroupName">(Me)</span></h5>
                  </div>
                </div>
              </td>
              <td class="col-btn" style="width:40px">
                <button pButton icon="fa fa-edit" (click)="showEditGroupDialog(rowData)" *ngIf="this.currentUser !== rowData.GroupName"></button>
              </td>
              <td class="col-btn" style="width:50px">
                <button pButton icon="fa fa-trash" (click)="deleteGroupData(rowData, reportSettingDefaultTab)" *ngIf="this.currentUser !== rowData.GroupName"></button>
              </td>
            </tr>
          </ng-template>
        </p-table>
        <ul class="list-group key-list">
          <li class="list list-group-item" [ngClass]="{'border-top': weeklyRecipientGroup.length> 0 }">
            <a class="add-link" (click)="showAddGroupDialog('week')">
              <div class="icon">
                <span class="fa-stack">
                  <i class="fa fa-circle fa-stack-2x"></i>
                  <i class="fa fa-plus fa-stack-1x fa-inverse"></i>
                </span>
              </div>
              <div class="data">
                {{'Add Group' | translate}}
              </div>
            </a>
          </li>
        </ul>
      </div>
    </p-tabPanel>
    <p-tabPanel header="{{'Monthly Report' | translate}}">
      <div class="dialog-content">
        <div class="form-group type">
          <div class="flex">
            <div>
              <label>{{'Enable Monthly Report' | translate}}</label>
              <small>{{'Reports are generated automatically and will only be sent via email when this feature is enabled.' | translate}}</small>
            </div>
            <p-inputSwitch [(ngModel)]="dialogReportSettingInput.monthlyEnable"></p-inputSwitch>
          </div>
        </div>
        <div class="form-group" style="margin-bottom: 0 !important;">
          <label>{{'Recipient Group' | translate}}</label>
        </div>
        <p-table class="recipientTable report" [ngClass]="{'border-top': monthlyRecipientGroup.length> 0 }" [value]="monthlyRecipientGroup" [(selection)]="monthlySelectedGroups" [paginator]="false" [rows]="10" [scrollable]="true">
          <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
            <tr [pSelectableRow]="rowData" [pSelectableRowIndex]="rowIndex">
              <td style="width: 40px; text-align: right;">
                <p-tableCheckbox [value]="rowData" [index]="rowIndex" [disabled]="!dialogReportSettingInput.monthlyEnable"></p-tableCheckbox>
              </td>
              <td class="col-nowrap">
                <div class="recipient">
                  <div class="data">
                    <h5 style="margin: 0;">{{rowData.GroupName}} <span *ngIf="this.currentUser === rowData.GroupName">(Me)</span></h5>
                  </div>
                </div>
              </td>
              <td class="col-btn" style="width:40px">
                <button pButton icon="fa fa-edit" (click)="showEditGroupDialog(rowData)" *ngIf="this.currentUser !== rowData.GroupName"></button>
              </td>
              <td class="col-btn" style="width:50px">
                <button pButton icon="fa fa-trash" (click)="deleteGroupData(rowData, reportSettingDefaultTab)" *ngIf="this.currentUser !== rowData.GroupName"></button>
              </td>
            </tr>
          </ng-template>
        </p-table>
        <ul class="list-group key-list">
          <li class="list list-group-item" [ngClass]="{'border-top': monthlyRecipientGroup.length> 0 }">
            <a class="add-link" (click)="showAddGroupDialog('month')">
              <div class="icon">
                <span class="fa-stack">
                  <i class="fa fa-circle fa-stack-2x"></i>
                  <i class="fa fa-plus fa-stack-1x fa-inverse"></i>
                </span>
              </div>
              <div class="data">
                {{'Add Group' | translate}}
              </div>
            </a>
          </li>
        </ul>
      </div>
    </p-tabPanel>
  </p-tabView> -->
  <div class="dialog-content">
    <div class="form-group type">
      <div class="flex" style="margin: 0 0 .2rem 0;">
        <label>{{'Enable Weekly Report' | translate}}</label>
        <p-toggleswitch [(ngModel)]="dialogReportSettingInput.weeklyEnable"></p-toggleswitch>
      </div>
      <div class="flex">
        <label>{{'Enable Monthly Report' | translate}}</label>
        <p-toggleswitch [(ngModel)]="dialogReportSettingInput.monthlyEnable"></p-toggleswitch>
      </div>
      <small>{{'Reports are generated automatically and will only be sent via email when this feature is enabled.' | translate}}</small>
    </div>
    <div class="form-group" style="margin-bottom: 0 !important; margin-top: 1.5rem">
      <label>{{'Recipient Group' | translate}}</label>
    </div>
    <p-table class="recipientTable report" [ngClass]="{'border-top': recipientGroup.length> 0 }" [value]="recipientGroup" [(selection)]="recipientSelectedGroups" [paginator]="false" [rows]="10" [scrollable]="true">
      <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
        <tr [pSelectableRow]="rowData" [pSelectableRowIndex]="rowIndex">
          <td style="width: 40px; text-align: right;">
            <p-tableCheckbox [value]="rowData" [index]="rowIndex" [disabled]="!dialogReportSettingInput.weeklyEnable && !dialogReportSettingInput.monthlyEnable"></p-tableCheckbox>
          </td>
          <td class="col-nowrap">
            <div class="recipient">
              <div class="data">
                <h5 style="margin: 0;">{{rowData.GroupName}} <span *ngIf="this.currentUser === rowData.GroupName">(Me)</span></h5>
              </div>
            </div>
          </td>
          <td class="col-btn" style="width:40px">
            <button pButton icon="fa fa-edit" (click)="showEditGroupDialog(rowData)" *ngIf="this.currentUser !== rowData.GroupName"></button>
          </td>
          <td class="col-btn" style="width:50px">
            <button pButton icon="fa fa-trash" (click)="deleteGroupData(rowData, reportSettingDefaultTab)" *ngIf="this.currentUser !== rowData.GroupName"></button>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <ul class="list-group key-list">
      <li class="list list-group-item" [ngClass]="{'border-top': recipientGroup.length> 0 }">
        <a class="add-link" (click)="showAddGroupDialog('week')">
          <div class="icon">
            <span class="fa-stack">
              <i class="fa fa-circle fa-stack-2x"></i>
              <i class="fa fa-plus fa-stack-1x fa-inverse"></i>
            </span>
          </div>
          <div class="data">
            {{'Add Group' | translate}}
          </div>
        </a>
      </li>
    </ul>
  </div>
  <ng-template #footer>
    <button type="button" pButton (click)="saveRecipientSetting();" label="{{'Save' | translate}}" class="ui-button-danger" *ngIf="!isMsp"></button>
    <!-- <button type="button" pButton (click)="saveRecipient();" label="Save" class="ui-button-danger" *ngIf="isMsp" [disabled]="dialogReportSettingInput.selectedWeeklyCompany === 0 || dialogReportSettingInput.selectedMonthlyCompany === 0"></button> -->
    <button type="button" pButton (click)="reportSettingsDialog=false;" label="{{'Cancel' | translate}}" class="p-button-secondary"></button>
  </ng-template>
</p-dialog>


<p-dialog header="{{dialogGroupInput.UpdateType}}" class="scrollDialog" [(visible)]="recipientGroupDialog" [modal]="true" [responsive]="true" [style]="{'width': '450px'}" [minWidth]="200" [baseZIndex]="10000">
  <div class="dialog-content">
    <div class="form-group">
      <label translate>Group Name</label>
      <input class="form-control pInputText" pInputText [(ngModel)]="dialogGroupInput.GroupName"
        (ngModelChange)="errGroupName = false" (blur)="checkGroupName()">
      <p-message severity="error" text="{{'Group Name already exists' | translate}}" *ngIf="errGroupName"></p-message>
      </div>
      <div class="form-group">
        <label translate>E-mail</label>
        <div class="flex align-items-none">
      
          <input type="email" class="form-control pInputText" pInputText [(ngModel)]="dialogGroupInput.Email"
            pattern="^[A-Za-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$" #revAddMemberEmail="ngModel"
            (ngModelChange)="errMail = false; errLimitExceeded = false" (blur)="checkEmail()">
      
          <button pButton icon="fa fa-plus" 
            [disabled]="!dialogGroupInput.Email || dialogGroupInput.Email.trim() === '' || errMail"
            (click)="controlGroupMember('addGroupMember');">
          </button>
        </div>
      
        <p-message class="error-message" severity="error" text="{{'Email is invalid or already exists' | translate}}" *ngIf="errMail">
        </p-message>
      
        <p-message class="error-message" severity="error" text="{{'The maximum number of emails has been reached' | translate}}"
          *ngIf="errLimitExceeded">
        </p-message>
      
      </div>
    <div class="form-group" style="margin-bottom: 0 !important;">
      <label><span translate>Recipient Members</span> ({{groupRecipientMemberList.length}}) </label>
    </div>
    <p-table class="recipientTable member" [ngClass]="{'border-top': groupRecipientMemberList.length> 0 }" [value]="groupRecipientMemberList" [paginator]="false" [rows]="10" [scrollable]="true" scrollHeight="288px">
      <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex">
        <tr [pSelectableRow]="rowData">
          <td class="col-nowrap">
            <div class="recipient">
              <div class="icon">
                <span class="fa-stack fa-lg">
                  <i class="fa fa-circle fa-stack-2x"></i>
                  <i class="fa-stack-1x name">{{rowData.Email.substr(0,1)}}</i>
                </span>
              </div>
              <div class="data">
                <h5 style="margin: 0;">{{rowData.Email}}</h5>
              </div>
            </div>
          </td>
          <td class="col-btn" style="width:50px">
            <button pButton icon="fa fa-trash" (click)="deleteRecipientGroupMember(i,rowData)"></button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <div translate class="ui-emptymessage">No Data found</div>
      </ng-template>
    </p-table>
  </div>

  <ng-template #footer>
    <button type="button" pButton (click)="saveGroupDialog()" label="{{'Save' | translate}}" class="ui-button-danger" 
      [disabled]="
        errMail || 
        errGroupName || 
        groupRecipientMemberList.length === 0 || 
        !dialogGroupInput.GroupName || 
        dialogGroupInput.GroupName.trim() === '' || 
        revAddMemberEmail.invalid">
    </button>
    <button type="button" pButton (click)="cancelDialog()" label="{{'Cancel' | translate}}" class="p-button-secondary"></button>
  </ng-template>
</p-dialog>
